import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby-theme-material-ui';
import Section from '../../shared/Section/Section';
import VideoBlock from '../../shared/VideoBlock/VideoBlock';
import styles from './styles';
import { sendYandexMetrikaEvent } from '../../helpers/yandexMetrika';
import PointsList from '../../shared/PointsList/PointsList';

function FAQ({ title, subtitle, data, ymSubmitEventType }) {
  return (
    <Section title={title} subtitle={subtitle} withoutBg>
      <Grid container sx={styles.container}>
        <Grid item xs={12} xl={6}>
          {data.content && (
            <Typography variant="desktopP1" sx={styles.description}>
              {data.content}
            </Typography>
          )}

          {data.list && (
            <Box sx={styles.list}>
              <PointsList list={data.list} iconSx={{ width: 16, height: 16 }} />
            </Box>
          )}
          {data.link && (
            <Link
              to={data.link.url}
              sx={styles.linkDesktop}
              variant="kitPrimary"
              typography="desktopP2"
              onClick={() => sendYandexMetrikaEvent(ymSubmitEventType)}
            >
              {data.link.title}
            </Link>
          )}
        </Grid>
        <Grid item xs={12} xl={6} sx={styles.videoWrapper}>
          <VideoBlock {...data}>
            <StaticImage src="./images/faq.png" alt="preview" />
          </VideoBlock>
        </Grid>
      </Grid>
      {data.link && (
        <Link
          to={data.link.url}
          sx={styles.linkMbile}
          variant="kitPrimary"
          typography="desktopP2"
          onClick={() => sendYandexMetrikaEvent(ymSubmitEventType)}
        >
          {data.link.title}
        </Link>
      )}
    </Section>
  );
}

export default FAQ;
